<template>
  <div id="inner-section-container">
    <div v-for="(item, index) in profile" v-bind:key="index" class="single-section">
      <div class="title-box box">
        <span class="grow">{{item.periodo}}</span>
        <!-- <img src="../assets/images/plusNero.svg"> -->
        <!-- <i class="rds-icon rds-icon-plusNero"></i> -->
        <span v-if="isCurrentUser" v-on:tap="plusClicked()" class="plus">
          <img src="../assets/images/add.svg" />
        </span>
      </div>
      <div class="description-box box">
        <div v-for="(val, ind)  in getValuesToShow(item)" v-bind:key="ind">{{val}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from '../services/EventBus';
export default {
  name: 'experiencecard',
  props: ['profile', 'isCurrentUser'],
  methods: {
    getValuesToShow(item) {
      let values = [];
      for (const key in item) {
        if (
          item.hasOwnProperty(key) &&
          key !== 'periodo' &&
          key !== 'startDate' &&
          key !== 'endDate'
        ) {
          values.push(item[key]);
        }
      }
      return values;
    },
    plusClicked() {
      eventBus.$emit('plusButtonClicked');
    }
  }
};
</script>
<style lang="scss" scoped>
.title-box,
.description-box {
  padding: 18px;
  letter-spacing: $default-letter-spacing;
}
.description-box {
  div {
    font-size: 0.95em;
    margin-bottom: 15px;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
.plus {
  display: flex;
}
.single-section {
  margin-bottom: 20px;
  &:nth-child(1) {
    .plus {
      display: flex;
    }
  }
  .plus {
    display: none;
  }
}
</style>
